function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.47266 0H8.52734C8.76432 0 8.92839 0.11849 9.01953 0.355469C9.11068 0.574219 9.07422 0.765625 8.91016 0.929688L5.38281 4.45703C5.27344 4.56641 5.14583 4.62109 5 4.62109C4.85417 4.62109 4.72656 4.56641 4.61719 4.45703L1.08984 0.929688C0.925781 0.765625 0.889323 0.574219 0.980469 0.355469C1.07161 0.11849 1.23568 0 1.47266 0Z",
  fill: "currentColor"
});

var SvgSortDown = function SvgSortDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSortDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort-down.fb9db24c.svg";
export { ForwardRef as ReactComponent };